module.exports = {
    siteUrl: `https://insights.sheyla.mx`, // Site domain. Do not include a trailing slash!

    postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

    siteTitleMeta: `Insights de Comercio Electrónico`, // This allows an alternative site title for meta data for pages.
    siteDescriptionMeta: `Lo que necesitas conocer sobre el comercio electrónico y el marketing digital para vender online y aumentar tus ventas.`, // This allows an alternative site description for meta data for pages.

    shareImageWidth: 1000, // Change to the width of your default share image
    shareImageHeight: 523, // Change to the height of your default share image

    shortTitle: `Sheyla.mx`, // Used for App manifest e.g. Mobile Home Screen
    siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
    backgroundColor: `#ffffff`, // Used for Offline Manifest
    themeColor: `#79c9d5`, // Used for Offline Manifest
}
